// currenciesSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  inputCurrency: null,
  outputCurrency: null,
};

const currenciesSlice = createSlice({
  name: 'currencies',
  initialState,
  reducers: {
    setCurrencies: (state, action) => {
      state.inputCurrency = action.payload.inputCurrency;
      state.outputCurrency = action.payload.outputCurrency;
    },
  },
});

export const { setCurrencies } = currenciesSlice.actions;
export const selectCurrencies = (state) => state.currencies;
export default currenciesSlice.reducer;


